var csrf_token, 
  railsHost = window.location.protocol + "//" + window.location.hostname,
  emailField = document.getElementById("form-email");

if (emailField) {
  //focus 
  emailField.addEventListener('focus', function() {
    var that = this,
    emailError = document.getElementById("email-error");
    
    //remove existing error
    if (emailError) {
      emailError.remove();
    }

    that.classList.remove("error-border");

    if (!csrf_token) {
      // XHR request for user token
      bsLib.ajax(
        "GET",
        railsHost + "/user/token.json",
        {},
        false,
        {},
        // Success message for user token.
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);
          csrf_token = dataRequest.csrf_token;
        },
        // Custom Error message for user token.
        function() {
          return "user token not working";
        }
      );
    }
  });

  emailField.addEventListener("blur", function(event) {
    var validEmail = true,
    that = this,
    submitBtn = document.getElementById("event_commit"),
    emailError = document.getElementById("email-error");

    //false valid dataset
    that.dataset.notvalid = "0";

    //remove existing error
    if (emailError) {
      emailError.remove();
    }

    if (that.value.length == 0 || !bsLib.validEmail(that.value)) {
      validEmail = false;
      
      that.classList.add("error-border");
      that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (Messages.emailValidationErrors.invalidEmail) + '</span>');
    } else {
      that.classList.remove("error-border");
    }

    if (validEmail) {
      //Disable submit button
      if (submitBtn) {
        submitBtn.setAttribute("disabled", "disabled");
        submitBtn.dataset.valueText = submitBtn.value;
        submitBtn.value = Messages.salesAndSupportPage.validateText;
      }

      //timeout added for display disabled btn functionality
      setTimeout(function () {
        bsLib.ajax(
          "GET",
          railsHost + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value),
          {},
          true,
          {
            "X-CSRF-Token": csrf_token,
            "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
          },
          function(data) {
            var dataRequest = bsLib.JSONParse(data.response);

            //remove disable
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.value = submitBtn.dataset.valueText;
            }
            
            if (dataRequest.valid === false) {
              that.dataset.notvalid = "1";

              that.classList.add("error-border");
              that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.emailValidationErrors.invalidEmail + '</span>');
            }
          },
          function() {}
        );
      }, 0);
    }
  });
}

/**
 * Recaptcha File load
 */
window.addEventListener("load", function() {
  // load recaptcha JS after page load
  document.addEventListener("click", function () {
    if (typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }
  });
});

var recaptchaCallback = function() {
  return formValidation();
};

//Reset captcha if expired
var expiredCaptchaCallback = function() {
  if (typeof grecaptcha !== "undefined") {
    grecaptcha.reset();
  }
};

function formValidationCaptcha() {
  var ContactForm = {},
  that = document.querySelector(".in-content-responsive-checker.contact-form");
  
  ContactForm.emailField = that.querySelector("[name='form-email']");

  ContactForm.emailError = document.getElementById("email-error");

  function form_validation(fieldName, fieldError, errorMessage, isEmail, emailErrorMessage) {

    //Clear error field
    fieldName.classList.remove("error-border");
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail) {

      if (fieldName.value == "") {
        fieldName.classList.remove("error-border");
        fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="name-error">' + errorMessage + '</span>');
        fieldName.classList.add("error-border");
      }
    } else {

      if (fieldName.value == "") {
        fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + errorMessage + '</span>');
        fieldName.classList.add("error-border");
      } else if (!bsLib.validEmail(fieldName.value)) {
        fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + emailErrorMessage + '</span>');
        fieldName.classList.add("error-border");
      } 

    }

  }

  form_validation(ContactForm.emailField, ContactForm.emailError, 'Invalid Email', true, 'Invalid Email');

  if (ContactForm.emailField.value == "" || !bsLib.validEmail(ContactForm.emailField.value)) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") { //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    ContactForm.emailField.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.emailValidationErrors.invalidEmail + '</span>');

    return false;
  } else {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.execute();
    }
  }
  return false;
}

function formValidation() {
  var ContactForm = {},
  submitBtn = document.getElementById("event_commit"),
  that = document.querySelector(".in-content-responsive-checker.contact-form");

  ContactForm.emailField = that.querySelector("[name='form-email']");
  ContactForm.status = that.querySelector("[name='form-status']");
  ContactForm.tag = that.querySelector("[name='form-tag']");
  ContactForm.pageview = that.querySelector("[name='form-page-view']");
  ContactForm.emailError = document.getElementById("email-error");

  function form_validation(fieldName, fieldError, errorMessage, isEmail, emailErrorMessage) {

    //Clear error field
    fieldName.classList.remove("error-border");
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail) {

      if (fieldName.value == "") {
        fieldName.classList.remove("error-border");
        fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="name-error">' + errorMessage + '</span>');
        fieldName.classList.add("error-border");
      }
    } else {

      if (fieldName.value == "") {
        fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + errorMessage + '</span>');
        fieldName.classList.add("error-border");
      } else if (!bsLib.validEmail(fieldName.value)) {
        fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + emailErrorMessage + '</span>');
        fieldName.classList.add("error-border");
      } 

    }

  }

  form_validation(ContactForm.emailField, ContactForm.emailError, 'Invalid Email', true, 'Invalid Email');

  if (ContactForm.emailField.value == "" || !bsLib.validEmail(ContactForm.emailField.value)) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") { //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    ContactForm.emailField.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + Messages.emailValidationErrors.invalidEmail + '</span>');

    return false;
  } else {

    var grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';

    if (grecaptchaResponse.length === 0) {
      new bsAlert({
        alertType: "error",
        timeout: 5000,
        text: Messages.salesAndSupportPage.noRecaptcha
      });

      return false;
    }

    //Disable submit button
    if (submitBtn) {
      submitBtn.setAttribute("disabled", "disabled");
      submitBtn.dataset.valueText = submitBtn.value;
      submitBtn.value = Messages.salesAndSupportPage.validateText;
    }

    // MailChimp Form Data object	
    var mcFormData = {
      email: ContactForm.emailField.value,
      curr_page_url: window.location.href,		
      status: ContactForm.status.value,
      tag: ContactForm.tag.value,
      "g-recaptcha-response": grecaptchaResponse,
      ga_cid: bsLib.GAClientID()
    };

    // xhr request for sending form data to MailChimp	
    bsLib.ajax(
      "POST",	 
      bsLib.railsHost() + "/wp-admin/admin-ajax.php",	
      {	
        action: "mailchimp_ajax_send_data",	
        security: ajax_initialize_script.ajax_nonce, // nonce	
        data: JSON.stringify(mcFormData)	
      },	
      true, //async	
      {	
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"	
      }, //request header	
      function() {
        var elements = document.getElementsByClassName("tingle-modal--visible"),
        modalContainer = document.querySelector('.enable-popup-modal');
        if (modalContainer && elements.length == 0 ) {
          var custModalVideo = new tingle.modal({
            onClose: function() {
              custModalVideo.destroy();
            }
          });
          custModalVideo.setContent(modalContainer.innerHTML);
          custModalVideo.open();

          //remove disable
          if (submitBtn) {
            submitBtn.removeAttribute("disabled");
            submitBtn.value = submitBtn.dataset.valueText;
          }

          //pageview
          if (typeof ga !== 'undefined' && ContactForm.pageview.value !== "" ) {
            ga('browserstack.send', 'pageview', ContactForm.pageview.value );
          }

          //reset email field
          ContactForm.emailField.value = "";
        }
      }, //success	
      function() {} //error object	
    );

    return true;
  }
}